    
<template>
  <common-page-layout>
    
    <span slot="fixedtopbuttons">
      <back-button v-if="!tempremedial" @click="$router.push('/admin/customerremedials/home')"/>      
      <back-button v-if="tempremedial" @click="tempremedial=null"/>      
      <save-button v-if="tempremedial && AuthsRemedialRights({remedial:tempremedial,check:'createremedials'})" @click="saveRemedial"/>    
      <add-button v-if="!tempremedial && AuthsAllBusinessRightCheck('createremedials')" @click="$refs.remedialdialog.add()"/>
      <add-button v-if="!tempremedial && AuthsAllBusinessRightCheck('createremedials')" @click="$refs.remedialdialog.lodge()">Lodge</add-button>   
      <add-button v-if="tempremedial"  @click="$refs.addnewnote.show()">Note</add-button>  
      <refresh-button v-if="tempremedial" @click="refresh({data:{remedial:tempremedial,business:tempremedial.business}})"/>
    </span>
    
    <p v-if="!tempremedial" class="w3-hide-small">
      <font color="green"><b>Here you can view listings of business remedials, Use the arrow Up/Down to show hide. Click the refresh button to load background changes.</b></font>
    </p>
    
    <remedials-table-layout :class="{'w3-hide':tempremedial}" :alladminrights="alladminrights" @remedialclick="refresh" />  
    
    <remedial-tabs-layout ref="remediallayout" @tabsActions="tabsActions" v-if="tempremedial" :remedial="tempremedial" :business="business"/> 
    
    <remedial-dialog ref="remedialdialog" />

    <add-note-dialog ref="addnewnote" id="addnewnote" headertext="Add Note" @noteadded="noteadded"/>

  </common-page-layout>
</template>


<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import authsMixin from '../../.././mixins/authsMixin'
  export default {
    mixins:[authsMixin],
    data: function() {
      return {
        tempremedial:null
      };
    },
    methods: {       
      ...mapActions(["remedialCommands","fullremedial"]),       
      tabsActions({action,data}){          
          if(action==='saveImage')
          {
              this.remedialCommands({command:'saveRemedialImageMeta',remedial:this.tempremedial,business:this.tempremedial.business,meta:{image:data.image}})
          }
     
      },  
      noteadded({data}){          
          this.remedialCommands({command:'addNoteToExistingRemedial',remedial:this.tempremedial,business:this.tempremedial.business,meta:{comment:data.note}})
      },
      saveRemedial(){           
        this.remedialCommands({command:'saveExistingRemedial',business:this.tempremedial.business,remedial:this.tempremedial})        
      },
      refresh({data}){          
          this.fullremedial({id:data.remedial.id,business:data.business}).then((res)=>{
              if(res)          
              {
                this.tempremedial = {id:data.remedial.id,...res} // || remedial            
              }
          })
      }    
    },
    computed: {
      ...mapGetters(["business","alladminrights"]),
    }
    
  };
</script>
 
 <style>

  .ul-layout{
    list-style-type: none;   
  }
   
  .li-layout {
    display: inline-block;
    max-width: 350px;
    padding: 10px;
  }    
  </style>
 


// WEBPACK FOOTER //
// src/components/admin/customerremedials/AdminCustomersRemedialsProcessing.vue